// extracted by mini-css-extract-plugin
module.exports = {"input":"components-userSearchQueryBuilder-config-widgets-widgets__input--2mhlb"};